export const rulerOptions = {
  wrapBg: 'transparent',
  lineH: 6, // 刻度高度
  lineW: 1, // 刻度宽度
  space: 5, // 刻度间距
  lineColor: 'rgba(0,0,0,0.08)', // 刻度颜色
  textColor: '#C8C8C8', // 字体颜色
  textSize: 12, // 字体大小
  wrapSize: 25 // 刻度线空间
}

export const referenceLineGroup = {
  draggable: true,
  name: 'referenceLineGroup'
}

export const referenceLineHoverArea = {
  name: 'referenceLineHoverArea',
  displayOffset: {
    line: -10, // 显示时与辅助线的偏移值，当是横向时则是 x 轴偏移值，当是纵向时则是 y 轴偏移值
    group: 0 // 显示时与坐标轴的偏移值，当是横向时则是与 y 轴偏移值，当是纵向时则是与 x 轴偏移值
  },
  width: 30,
  height: 50
}

export const referenceLinePanel = {
  displayOffset: {
    line: 4, // 显示时与辅助线的偏移值，当是横向时则是 x 轴偏移值，当是纵向时则是 y 轴偏移值
    group: 30 // 显示时与坐标轴的偏移值，当是横向时则是与 y 轴偏移值，当是纵向时则是与 x 轴偏移值
  },
  fontSize: 12, // 字体大小
  fill: '#666', // 字体颜色
  name: 'referenceLinePanel'
}

export const referenceLineCloseBtnGroup = {
  displayOffset: {
    line: -10, // 显示时与辅助线的偏移值，当是横向时则是 x 轴偏移值，当是纵向时则是 y 轴偏移值
    group: 30 // 显示时与坐标轴的偏移值，当是横向时则是与 y 轴偏移值，当是纵向时则是与 x 轴偏移值
  },
  points: [
    [0, 0, 6, 6],
    [0, 6, 6, 0]
  ],
  strokeWidth: 1,
  stroke: '#aaaaaa',
  name: 'referenceLineClose'
}

// 辅助线配置
export const referenceLineOptions = {
  strokeWidth: 1, // 参考线宽度
  stroke: '#F5222D', // 刻度颜色
  name: 'referenceLine'
}

// 捕捉辅助线配置
export const guideLineOptions = {
  strokeWidth: 1, // 参考线宽度
  name: 'guideLine',
  dash: [4, 6],
  stroke: 'rgb(0, 161, 255)' // 刻度颜色
}
